import React, { useState, createContext, useContext } from 'react';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { lightTheme, darkTheme } from "../theme/index.js";
const DarkModeContext = createContext(null);
export const DarkModeProvider = ({
  children
}) => {
  const [dark, setDark] = useState(false);
  return /*#__PURE__*/React.createElement(DarkModeContext.Provider, {
    value: () => setDark(!dark)
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: dark ? darkTheme : lightTheme
  }, /*#__PURE__*/React.createElement(CssBaseline, null), children));
};
DarkModeProvider.displayName = 'DarkModeProvider';
export const useDarkModeToggle = () => {
  const ctx = useContext(DarkModeContext);
  if (ctx === null || ctx === undefined) throw new Error(`Maybe you forgot wrap your parent component with the 'DarkModeProvider'`);
  return ctx;
};